<template>
  <MainLayout section="tags">
    <b-container fluid id="tags-container" v-bind:class="$mq">
      <b-row id="tags-header">
        <b-col cols=11 class="p-0">
          <h2><u>Tags</u></h2>
        </b-col>

        <b-col style="text-align: right" class="p-0">
          <span id="new_tag" v-b-modal.new_tag_dialog>
            <h3>+</h3>
          </span>

          <b-modal id="new_tag_dialog"
                   title="New Tag"
                   v-on:show="specified_tag = specified_address = ''"
                   v-on:ok="new_tag"
                   v-bind:ok-disabled="specified_tag == '' || specified_address == ''">
            <b-form-input placeholder="Tag"     v-model="specified_tag" />
            <b-form-input placeholder="Account" v-model="specified_address" />
          </b-modal>
        </b-col>
      </b-row>

      <b-row id="tags-content">
        <b-col>
          <b-list-group v-bind:key="tags_key">
            <b-list-group-item v-for="tag in tags.user_tags()"
                               v-bind:key="tag"
                               class="tag">
              {{tag}}

              <b-list-group-item
                 v-for="address in tags.addresses_for_user_tag(tag)"
                 :key="tag + '_' + address"
                 class="tagged_account"
                 :class="$mq">
                <AccountLink :account="address" no_tag />
                <span class="rm_tag" v-on:click="rm_tag(address, tag)">-</span>
              </b-list-group-item>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>

      <b-row v-if="!have_tags" id="tags-info">
        <b-col>
          <p><i>Tag accounts with custom labels and content for easy lookup.</i></p>
        </b-col>
      </b-row>

      <b-row id="builtin-tags-link"
             v-b-toggle.builtin-tags-collapse>
        <b-col>
          Builtin Tags <span class="opened">⮟</span><span class="closed">⮞</span>
        </b-col>
      </b-row>

      <b-row id="builtin-tags" :class="$mq">
        <b-col>
          <b-collapse id="builtin-tags-collapse" class="mt-2">
            <renderjson :data="tags.builtin" level=2 no_expand_hide />
          </b-collapse>
        </b-col>
      </b-row>

      <b-row v-if="have_tags" v-bind:key="tags_key" style="flex-wrap: nowrap">
        <b-col cols=10>
        </b-col>

        <b-col style="text-align: right">
          <span id="clear_tags" v-on:click="clear_tags">Clear</span>
        </b-col>
      </b-row>
    </b-container>
  </MainLayout>
</template>

<script>
import MainLayout  from './components/MainLayout.vue';
import AccountLink from './components/AccountLink.vue'

import renderjson from './vendor/renderjson/renderjson.vue'

import tags from './tags'

export default {
  name: 'Tags',

  components: {
    MainLayout,
    AccountLink,
    renderjson
  },

  data : function(){
    return {
      tags_key : 0,
      specified_tag : '',
      specified_address : '',
    }
  },

  computed : {
    tags : function(){
      return tags;
    },

    have_tags : function(){
      // XXX: tags not reactive (fix)
      this.tags_key;

      return tags.user_tags().length > 0;
    }
  },

  methods : {
    new_tag : function(){
      tags.create_tag(this.specified_address, this.specified_tag);

      // XXX: tags not reactive (fix)
      this.tags_key += 1;
    },

    rm_tag : function(a, t){
      tags.rm_tag(a, t);

      // XXX: tags not reactive (fix)
      this.tags_key += 1;
    },

    clear_tags : function(){
      tags.clear();

      // XXX: tags not reactive (fix)
      this.tags_key += 1;
    }
  }
}
</script>

<style scoped>
#tags-container{
  padding: 50px;
  margin: 0;
  height: 100%;
  background: #eef1f6;
}

#new_tag,
#clear_tags,
.rm_tag{
  color: blue;
  cursor: pointer;
}

.form-control{
  margin: 5px;
}

#tags-header,
#tags-content,
#tags-info,
#builtin-tags-link,
#builtin-tags{
  background-color: white;
  border-radius: 5px;
  padding: 10px;
}

#builtin-tags-link{
  padding-left: 30px;
  padding-bottom: 0;
  color: #007bff;
  cursor: pointer;
}

#builtin-tags{
  padding-left: 50px;
  padding-right: 50px;
  padding-top: 0;
}

#builtin-tags.sm{
  padding-left: 30px;
  padding-right: 30px;
}

#builtin-tags-collapse{
  border: 1px solid black;
  max-height: 750px;
  overflow: auto;
}


#builtin-tags-link.collapsed .opened,
#builtin-tags-link:not(.collapsed) .closed{
  display: none;
}

#tags-info{
  text-align: center;
  font-size: 1.3rem;
}

.tag{
  border: none;
}

.tagged_account{
  display: flex;
  justify-content: space-between;
}

.tagged_account.sm{
  font-size: 0.6rem;
}
</style>
